import * as React from 'react'
import { SVGProps } from 'react'

const SvgJadvalVazni = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.611 5.845a.545.545 0 0 1-.156-.39v-.693h.007l.15 1.083Zm0 0a.545.545 0 0 0 .389.163m-.389-.163.389.163m0 0a.545.545 0 0 0 .389-.163L12 6.008Zm-.445-1.346v-.107l-.107.007c-1.536.108-2.93.656-4.035 1.512l-.09.07.08.08.819.818.002.002a.446.446 0 0 1-.309.768.445.445 0 0 1-.318-.135l-.853-.853-.073-.073-.07.076c-.97 1.037-1.6 2.352-1.732 3.8l-.01.11H11.584l.028-.056 1.628-3.247v-.001a.446.446 0 0 1 .376-.25.446.446 0 0 1 .417.647l-1.38 2.762-.073.144h6.561l-.01-.109C19 9.18 18.369 7.864 17.4 6.827l-.07-.076-.074.073-.852.852-.001.001a.445.445 0 1 1-.626-.633l.001-.002.818-.818.08-.08-.089-.07c-1.104-.857-2.499-1.404-4.035-1.512l-.107-.007v.901a.445.445 0 0 1-.763.319.445.445 0 0 1-.127-.319v-.794ZM.1 3.818A3.722 3.722 0 0 1 3.818.1h16.364A3.722 3.722 0 0 1 23.9 3.818v16.364a3.722 3.722 0 0 1-3.718 3.718H3.818A3.722 3.722 0 0 1 .1 20.182V3.818ZM20.182.991H3.818A2.81 2.81 0 0 0 .991 3.818v16.364a2.81 2.81 0 0 0 2.827 2.827h16.364a2.81 2.81 0 0 0 2.827-2.827V3.818A2.81 2.81 0 0 0 20.182.991ZM3.918 11.18c0-4.17 3.639-7.536 8.082-7.536 4.443 0 8.082 3.365 8.082 7.537 0 .246-.2.445-.446.445H4.364a.445.445 0 0 1-.446-.445Zm3.608-3.434a.545.545 0 0 0 .389.165l-.39-.165Z"
      fill="currentColor"
      stroke="#8B8F9A"
      strokeWidth={0.2}
    />
  </svg>
)

export default SvgJadvalVazni
